import React, {useState, useEffect} from 'react';
import Card from './Card';
import Data from '../data/home';


function Home(props) {
    const [homeData, setHomeData] = useState(Data);
    const [cardData, setCardData] = useState([]);
        return ( 
            <>
                <div className="container" style={{ marginTop: '30px' }}>
                    <div className="row">
                        <div className="col-lg-12 mb-4 mt-2">
                        <h2 style={{ fontWeight: '700'}}>{homeData.content[props.id - 1].title }</h2>
                        <div dangerouslySetInnerHTML={{ __html: homeData.content[props.id - 1].body }} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
export default Home;